import React from 'react';
import { useLocation } from 'react-router-dom';
import { getEnvironmentVariables } from 'services/environment-variables/environment-variables';

const buildRedirectUrl = (pathname: string): string | null => {
  const env = getEnvironmentVariables();

  // Remove leading slash and split path
  const pathParts = pathname.replace(/^\//, '').split('/');

  // Check if this is a venue path
  if (pathParts[0] === 'venue' && pathParts[1]?.length) {
    const venueId = pathParts[1];

    // Rule 1: mm_hostname/venue/:venueId -> connect_hostname/venue/:venueId/menus
    if (pathParts.length === 2) {
      return `${env.CONNECT_URL}/venue/${venueId}/menus`;
    }

    // Rule 2a: mm_hostname/venue/:venueId/menus -> connect_hostname/venue/:venueId/menus
    // Rule 2b: mm_hostname/venue/:venueId/menus/:menuId -> connect_hostname/venue/:venueId/menus/:menuId
    // Rule 2c: mm_hostname/venue/:venueId/menus/:menuId/* -> connect_hostname/venue/:venueId/menus/:menuId/*
    if (pathParts.length >= 3 && pathParts[2] === 'menus') {
      return `${env.CONNECT_URL}${pathname}`;
    }

    // Exclude boost paths from redirection
    if (pathParts.length === 3 && pathParts[2] === 'boost') {
      return null;
    }

    // Rule 3: mm_hostname/venue/:venueId/* -> connect_hostname/venue/:venueId/menus/*
    if (pathParts.length > 2) {
      const remainingPath = pathParts.slice(2).join('/');
      return `${env.CONNECT_URL}/venue/${venueId}/menus/${remainingPath}`;
    }
  }

  return `${env.CONNECT_URL}`;
};

const useConnectRedirection = (): void => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    const redirectUrl = buildRedirectUrl(pathname);

    if (redirectUrl) {
      // Use window.location.replace to avoid adding to browser history
      window.location.replace(redirectUrl);
    }
  }, [pathname]);
};

export default useConnectRedirection;
